import React from 'react';
const engagements = [{
  format: 'Inflection Diagnostic',
  structure: 'Diagnose bottlenecks + define 30-day plan',
  model: 'Fixed investment'
}, {
  format: 'Execution Sprint',
  structure: 'End-to-end milestone ownership',
  model: 'Fixed project pricing'
}, {
  format: 'Fractional Partnership',
  structure: 'Embedded leadership at inflection points',
  model: 'Monthly retainer'
}];
export function EngagementsSection() {
  return <section id="engagements" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-26">
      <div className="mb-16 sticky top-20 md:static bg-white pb-6 md:pb-0 -mx-6 px-6 md:mx-0 md:px-0 z-10" data-id="element-27">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-28">
          Engagements
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-29">
          Short-term. Embedded. Outcome-driven.
        </h3>
        <p className="text-xl text-gray-600 font-light" data-id="element-30">
          I step in when momentum is at risk. Work typically starts with a
          focused diagnostic or a defined execution sprint, and often evolves
          into fractional partnership at key inflection points.
        </p>
      </div>

      {/* Column headers — desktop only */}
      <div className="hidden md:grid md:grid-cols-12 gap-8 pb-4 border-b border-gray-200 mb-0" data-id="element-31">
        <div className="col-span-4" data-id="element-32">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-33">
            Format
          </span>
        </div>
        <div className="col-span-5" data-id="element-34">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-35">
            Structure
          </span>
        </div>
        <div className="col-span-3" data-id="element-36">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-37">
            Model
          </span>
        </div>
      </div>

      {/* Rows */}
      <div className="divide-y divide-gray-100" data-id="element-38">
        {engagements.map(row => <div key={row.format} className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-8 py-8 md:py-10 items-baseline" data-id="element-39">
            {/* Format */}
            <div className="md:col-span-4" data-id="element-40">
              <span className="text-lg font-medium text-black" data-id="element-41">
                {row.format}
              </span>
            </div>

            {/* Structure */}
            <div className="md:col-span-5" data-id="element-42">
              {/* Mobile label */}
              <span className="block text-xs font-bold uppercase tracking-widest text-gray-400 mb-1 md:hidden" data-id="element-43">
                Structure
              </span>
              <span className="text-base text-gray-600 leading-relaxed" data-id="element-44">
                {row.structure}
              </span>
            </div>

            {/* Model */}
            <div className="md:col-span-3" data-id="element-45">
              {/* Mobile label */}
              <span className="block text-xs font-bold uppercase tracking-widest text-gray-400 mb-1 md:hidden" data-id="element-46">
                Model
              </span>
              <span className="text-base text-gray-500" data-id="element-47">{row.model}</span>
            </div>
          </div>)}
      </div>
    </section>;
}